import { buildColorAccessor, getStatusFeature, MetricsNeutralColor, ThresholdStatus } from '../features/status';
import { DataRow, EffectiveDefinition } from '../models';
import { accessorForReference } from '../models/Accessor';

export interface StatusIndicatorBarModel {
  readonly color: string;
  readonly status: ThresholdStatus;
}

export const buildStatusIndicatorBarModel = (
  definition: EffectiveDefinition,
  latestValue?: DataRow
): StatusIndicatorBarModel => {
  const statusFeature = getStatusFeature(definition.features);
  const status =
    (statusFeature && latestValue && accessorForReference<ThresholdStatus>(statusFeature.status)(latestValue)) ??
    ThresholdStatus.UNKNOWN;

  const color = latestValue ? buildColorAccessor(definition)(latestValue) : MetricsNeutralColor;

  return {
    color,
    status,
  };
};
